export const DATASET_PANEL_ID = 'DatasetPanel';
export const DATASET_PROP = 'datasets';
export const DEVIATIONS_PROP = 'deviations';
export const DATASET_QUERY_LIMIT_DEFAULT = 50;